import seapointLogo from '../../../../assets/images/logo-seapoint.svg';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';
import { cn } from '../../../../utils/cn';

type OpenSeapointAccountProps = {
  className?: string;
  onOpenAccount?: () => void;
};

export const OpenSeapointAccount = ({ onOpenAccount, className }: OpenSeapointAccountProps) => {
  return (
    <div className={cn('border-seapoint-gray-borde w-full rounded-lg border-[0.5px] p-6', className)}>
      <Inline align="center" justify="between" className="w-full" wrap="nowrap">
        <Inline align="center" space={4}>
          <img src={seapointLogo} alt="" loading="eager" fetchPriority="high" className="h-8" />

          <Stack space={1}>
            <h3 className="text-base font-semibold leading-[22px] -tracking-[0.02em] text-black">
              Open a smarter business account
            </h3>
            <p className="text-sm leading-[22px] -tracking-[0.02em] text-seapoint-gray-text">
              Automate finance ops and get full control, with funds safeguarded at top-tier banks.
            </p>
          </Stack>
        </Inline>
        <Button variant="default" size="default" onClick={onOpenAccount}>
          Open Seapoint Account
        </Button>
      </Inline>
    </div>
  );
};
